import { Container } from 'react-bootstrap'
import styled from 'styled-components'
export const PersonalInfoSection = styled.div`
    padding-top: .5rem;
    >h4{
        margin-bottom:.5rem;
        font-family:${({ theme }) => theme.font.first};
        font-weight:700;
        color: ${({ theme }) => theme.color.fourth};
    }
`
export const PersonalInfoCard = styled.div`
    padding: 1rem;
    background-color: ${({ theme }) => theme.color.third};
    border-radius:5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    >.Typewriter__wrapper,
    >h3{
        font-family:${({ theme }) => theme.font.first};
        text-align: center;
    }
    >h3{
        color:${({ theme }) => theme.color.first};
        position: relative;
        margin-bottom:1rem;
        font-weight:300;
        &::after{
            position: absolute;
            content: '';
            height: 2px;
            bottom: -8px; 
            margin: 0 auto;
		    left: 0;
            right: 0;
		    width: 25%;
		    background-color: ${({ theme }) => theme.color.second};
        }
    }
    .Typewriter__wrapper{
        color:${({ theme }) => theme.color.sixth};
        font-size:32px;
    }
    .Typewriter__cursor{
        color:${({ theme }) => theme.color.first};
        font-size:32px;
        font-weight:700;
    }
    >p{
        margin-bottom:.5rem;
        font-family:${({ theme }) => theme.font.second};
        font-weight:400;
        color: ${({ theme }) => theme.color.fourth};
        text-align: justify;
    }
`
export const DisplayPicture = styled.div`
    height: 150px;
    width: 150px;
    border-radius:50%;
    background-color: ${({ theme }) => theme.color.second};
    border:2px solid ${({ theme }) => theme.color.second};
    margin-bottom: 1rem;
    overflow: hidden;
    >img{
        height: 100%;
        width: 100%;
        transition: transform .3s;
        &:hover{
            transform: scale(1.2);
        }
    }
    
`